import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from './i18n'
import { Scroll } from 'vuetify/lib/directives'
import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  directives: {
    Scroll,
    Ripple
  }
})

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#252626',
        secondary: '#E6B535',        
        tertiary: '#6c757d',        
        accent: '#195e83',
        error: '#f55a4e',
        info: '#00d3ee',
        success: '#5cb860',
        warning: '#ffa21a'        
      }
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  icons: {
    iconfont: 'mdi',
  },
});
